/**
 * Dashboard Constants
 * Immutable constants used throughout dashboard
 */
const DashboardConstants = {
  STATION_TYPES: {
    AWLR: "AWLR",
    TMAS: "TMAS",
    ARR: "ARR",
    AWLR_ARR: "AWLR_ARR",
    AWS: "AWS",
    FM: "FM",
    TMAT: "TMAT",
    AGWLR: "AGWLR",
    OW: "OW",
    VNOTCH: "VNOTCH",
    WQ: "WQ",
    OSP: "OSP",
    AVWR: "AVWR",
  },

  WARNING_STATUS: {
    NORMAL: 0,
    AWAS: 1,
    SIAGA: 2,
    WASPADA: 3,
  },

  INTENSITY: {
    BERAWAN: 0,
    HUJAN_RINGAN: 1,
    HUJAN_SEDANG: 2,
    HUJAN_LEBAT: 3,
    HUJAN_SANGAT_LEBAT: 4,
  },

  STORAGE_KEYS: {
    STATION_ID: "station_id",
    DEVICE_ID: "device_id",
    LAST_STATION_NAME: "last_station_name",
    ACTIVE_TAB: "tab-center-left",
  },

  TABS: {
    AWLR: "tab-awlr",
    ARR: "tab-arr",
    AWLR_ARR: "tab-awlr-arr",
    AWS: "tab-aws",
    FM: "tab-fm",
  },

  MARKER_CLASSES: {
    AWLR: "awlr-marker",
    TMAT: "agwlr-marker",
    AGWLR: "agwlr-marker",
    OW: "ow-marker",
    ARR: "arr-marker",
    AWLR_ARR: "awlr-arr-marker",
    AWS: "aws-marker",
    FM: "fm-marker",
    VNOTCH: "vnotch-marker",
    WQ: "wq-marker",
    OSP: "osp-marker",
    AVWR: "avwr-marker",
    EWS: "ews-marker",
  },

  AWS_SENSORS: {
    HUMIDITY: "humidity",
    RAINFALL: "rainfall",
    TEMPERATURE: "temperature",
    PRESSURE: "pressure",
    EVAPORATION: "evaporation",
    WIND_DIRECTION: "winddirection",
    WIND_SPEED: "windspeed",
    SOLAR_RADIATION: "solarradiation",
  },

  SENSOR_TRANSLATIONS: {
    Humidity: "Kelembaban",
    RainfallLastHour: "Curah Hujan",
    Pressure: "Tekanan",
    Temperature: "Suhu",
    SolarRadiation: "Radiasi Matahari",
    WindDirection: "Arah Angin",
    WindSpeed: "Kecepatan Angin",
    Evaporation: "Penguapan",
    Uv: "UV",
  },

  SENSOR_UNITS: {
    Humidity: "%",
    RainfallLastHour: "mm",
    Pressure: "hPa",
    Temperature: "°C",
    SolarRadiation: "W/m²",
    WindDirection: "°",
    WindSpeed: "m/s",
    Evaporation: "mm",
    Uv: "",
  },

  /** Satuan volume Flow Meter (meter kubik) */
  FLOW_METER_UNIT: "m³",

  STATION_CONFIG: {
    AWLR: { name: "Pos Duga Air", classMarker: "awlr-marker me-1" },
    TMAS: { name: "Pos Duga Air", classMarker: "awlr-marker me-1" },
    TMAT: { name: "Pos Muka Air Tanah", classMarker: "agwlr-marker me-1" },
    AGWLR: { name: "Pos Muka Air Tanah", classMarker: "agwlr-marker me-1" },
    OW: { name: "Pos Observation Well", classMarker: "ow-marker me-1" },
    ARR: { name: "Pos Curah Hujan", classMarker: "arr-marker me-1" },
    VNOTCH: { name: "Pos V-Notch", classMarker: "vnotch-marker me-1" },
    AWS: { name: "Pos Klimatologi", classMarker: "aws-marker me-1" },
    WQ: { name: "Pos Kualitas Air", classMarker: "wq-marker me-1" },
    FM: { name: "Pos Flow Meter", classMarker: "fm-marker me-1" },
    AWLR_ARR: { name: "PDA & PCH", classMarker: "awlr-arr-marker me-1" },
    OSP: { name: "Pos Open Stand Pipe", classMarker: "osp-marker me-1" },
    AVWR: { name: "Pos Vibrating Wire", classMarker: "avwr-marker me-1" },
  },

  ONLINE_THRESHOLD: {
    HOURS: 12,
    MINUTES: 5,
  },
};

// Freeze constants to prevent modifications
Object.freeze(DashboardConstants);
Object.keys(DashboardConstants).forEach((key) => {
  if (typeof DashboardConstants[key] === "object") {
    Object.freeze(DashboardConstants[key]);
  }
});
